/**
 * Default: Components / Shared > Slider
 *
 * @copyright 2024 i-fabrik GmbH
 * @author Heiko Pfefferkorn
 */

import {extend} from '@ifabnpm/bootstrap/utils.js';

import {
	SelectorEngine,
	Data,
	Manipulator,
	EventHandler
} from '@ifabnpm/bootstrap/dom.js';

import Slider from '@ifabnpm/bootstrap/component/slider.js';

// -------
// Private
// -------

const sliderDefault = async (element, o = {}) => {
	return Slider.init(element, o);
};

const sliderImages = async (element, o = {}) => {
	const _o = extend({}, {
		slidesPerView: 'auto',
		spaceBetween : 0
	}, o);

	return Slider.init(element, _o);
};

/*const sliderEventHero = async (element, o = {}) => {
	const _o = extend({}, {
		grabCursor    : true,
		// effect        : 'fade',
		// fadeEffect    : {
		// 	crossFade: true
		// },
		effect        : 'creative',
		creativeEffect: {
			// Vertical
			// prev: {
			// 	opacity  : 0,
			// 	origin   : 'center top',
			// 	rotate   : [-180, 0, 0],
			// 	shadow   : false,
			// 	translate: [0, 0, -200]
			// },
			// next: {
			// 	opacity  : 0,
			// 	origin   : 'center bottom',
			// 	rotate   : [180, 0, 0],
			// 	shadow   : false,
			// 	translate: [0, 0, -200]
			// }
			// Horizontal
			// prev: {
			// 	opacity  : 0,
			// 	shadow   : false,
			// 	origin   : 'left center',
			// 	translate: ['-5%', 0, -200],
			// 	rotate   : [0, 100, 0]
			// },
			// next: {
			// 	opacity  : 0,
			// 	shadow   : false,
			// 	origin   : 'right center',
			// 	translate: ['5%', 0, -200],
			// 	rotate   : [0, -100, 0]
			// }
			// Scale
			prev: {
				opacity  : 0,
				origin   : 'center top',
				scale   : 0.5,
				shadow   : false
			},
			next: {
				opacity  : 0,
				origin   : 'center bottom',
				scale   : 1,
				shadow   : false
			}
		},
		spaceBetween  : 0,
		speed         : 600
	}, o);

	return Slider.init(element, _o);
};*/

/*const sliderEventDetailMedia = async (element, o = {}) => {
	const _o = extend({}, {
		grabCursor    : true,
		// effect        : 'fade',
		// fadeEffect    : {
		// 	crossFade: true
		// },
		effect        : 'creative',
		creativeEffect: {
			// Vertical
			// prev: {
			// 	opacity  : 0,
			// 	origin   : 'center top',
			// 	rotate   : [-180, 0, 0],
			// 	shadow   : false,
			// 	translate: [0, 0, -400]
			// },
			// next: {
			// 	opacity  : 0,
			// 	origin   : 'center bottom',
			// 	rotate   : [180, 0, 0],
			// 	shadow   : false,
			// 	translate: [0, 0, -400]
			// }
			// Horizontal
			// prev: {
			// 	opacity  : 0,
			// 	shadow   : false,
			// 	origin   : 'left center',
			// 	translate: ['-5%', 0, -200],
			// 	rotate   : [0, 100, 0]
			// },
			// next: {
			// 	opacity  : 0,
			// 	shadow   : false,
			// 	origin   : 'right center',
			// 	translate: ['5%', 0, -200],
			// 	rotate   : [0, -100, 0]
			// }
			// Scale
			prev: {
				opacity  : 0,
				// origin   : 'center top',
				scale   : 0.5,
				shadow   : false
			},
			next: {
				opacity  : 0,
				// origin   : 'center bottom',
				scale   : 1,
				shadow   : false
			}
		},
		spaceBetween  : 0,
		speed         : 600
	}, o);

	return Slider.init(element, _o);
};*/

/*const bindPlayPause = async (element) => {
	EventHandler.on(document, 'click', '.slider-controls .swiper-autoplay-toggle', (event) => {
		event.preventDefault();
		event.stopPropagation();

		const parents = SelectorEngine.parents(event.target, '.slider');
		const api = parents[0] ? Data.get(parents[0], 'ifab.slider.data-api') : null;

		if (api) {
			const flag = Manipulator.getAria(event.target, 'pressed');

			if (flag) {
				api.autoplay.resume();
				Manipulator.setAria(event.target, 'pressed' , 'false');
			} else {
				api.autoplay.pause();
				Manipulator.setAria(event.target, 'pressed' , 'true');
			}
		} else {
			Manipulator.setDisabled(event.target);
		}
	});

	// const toggle = SelectorEngine.find('.slider-controls .swiper-toggle-autoplay', element);
	//
	// if (toggle) {
	// 	console.log(toggle, element);
	// 	console.log(Data.get(element, 'ifab.slider.data-api'));
	//
	//
	// }
};*/

/**
 * Alle verfügbaren Slider (Attribut `data-slider`) initialisieren.
 *
 * @param o
 *
 * @returns {HTMLElement|Array}
 */
const init = async (o = {}) => {
	let group   = [];
	let options = extend({}, {
		navigation: {
			addIcons: false
		},
		pagination: {
			clickable         : true,
			renderBullet: function(index, className) {
				const rnd = (Math.floor(Math.random() * 5) + 1);

				return `<span class="${className}">
					<svg aria-hidden="true" preserveAspectRatio="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style="--svg-bullet-${rnd}-visible:1;">
						<use xlink:href="#svg-slider-bullets"/>
					</svg>
				</span>`;
			}
		}
	}, o);

	const collection = SelectorEngine.find(`[data-c^="slider"]`, document.documentElement);

	for (const element of collection) {
		switch (element.dataset.c) {
			case 'slider-images': {
				const inst = await sliderImages(element, options);

				group.push(inst);

				break;
			}
			// case 'slider-event-hero': {
			// 	const inst = await sliderEventHero(element, options);
			//
			// 	group.push(inst);
			//
			// 	break;
			// }
			// case 'slider-event-detail-media': {
			// 	const inst = await sliderEventDetailMedia(element, options);
			//
			// 	group.push(inst);
			//
			// 	break;
			// }
			default: {
				const inst = await sliderDefault(element, options);

				group.push(inst);

				break;
			}
		}
	}

	// await bindPlayPause();

	return group;
};

// ------
// Public
// ------

// Export
export default {
	init   : init,
	rebuild: Slider.rebuild//,
	// bindPlayPause : bindPlayPause,
};
